/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 09:41:54
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import { EnumCompareTaskConfirmStatus } from 'src/enums/enumCompareTaskStatus';
import CompareTaskConfirmApi from './api/compareTaskConfirmApi';

export namespace BatchConfirmVOI {
    export interface PropsI {
        ids: number[];
        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        affirm_condition: number;
        affirm_cause: string;
    }
}

@Component
class BatchConfirmModal extends Vue.Component<BatchConfirmVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Array,
    })
    ids!: number[];

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: BatchConfirmVOI.FormDataI = {
        affirm_condition: EnumCompareTaskConfirmStatus.现场条件允许.getId(),
        affirm_cause: '',
    };
    rules: any = {};

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (this.formData.affirm_condition === EnumCompareTaskConfirmStatus.现场条件不允许.getId() && !this.formData.affirm_cause) {
            return Toast.error('请填写原因');
        }
        this.loading = true;
        let params: any = {
            ids: this.ids,
            affirm_condition: this.formData.affirm_condition,
            affirm_cause:
                this.formData.affirm_condition === EnumCompareTaskConfirmStatus.现场条件不允许.getId() ? this.formData.affirm_cause : '',
        };
        let res = await CompareTaskConfirmApi.batchConfirm(params);
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success('操作成功！');
            this.saveSuccess();
            this.closeModal();
        }
    }

    render(h) {
        return (
            <Modal title="批量确认" width="500" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    <form-item label="确认：" style="display: inline-block;width:90%" required type="number" prop="affirm_condition">
                        <CommonSelect dataSource={EnumCompareTaskConfirmStatus.getList()} v-model={this.formData.affirm_condition} />
                    </form-item>
                    <form-item
                        label="原因："
                        style="display: inline-block;width:90%"
                        v-if={this.formData.affirm_condition === EnumCompareTaskConfirmStatus.现场条件不允许.getId()}
                    >
                        <Input placeholder="请输入" v-model={this.formData.affirm_cause} type="textarea" />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertBatchConfirmModal(ids: number[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<BatchConfirmVOI.PropsI>(BatchConfirmModal)({
            ids,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
